import { API, requireResponse } from './http';
export { API } from './http';

export async function streamRequest(path, payload, { onDelta, onResult, headers = {}, credentials = 'omit', signal } = {}) {
  const response = await requireResponse(await fetch(`${API}${path}`, {
    method: 'POST', signal, credentials, cache: 'no-store',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(payload),
  }));
  if (!response.body) throw new Error('Streaming is unavailable. Please try again.');
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '', completed = false;
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const events = buffer.split('\n\n');
      buffer = events.pop();
      for (const event of events) {
        const line = event.trim();
        if (!line.startsWith('data:')) continue;
        const raw = line.slice(5).trim();
        if (raw === '[DONE]') { completed = true; continue; }
        const data = JSON.parse(raw);
        if (data.error) throw new Error(data.error);
        if (data.delta) onDelta?.(data.delta);
        if (data.result !== undefined) onResult?.(data.result);
      }
    }
    if (!completed) throw new Error('The connection ended early. Please try again.');
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}

export async function copyText(text) {
  if (!text.trim()) return;
  await navigator.clipboard.writeText(text);
}